module.exports = __webpack_public_path__ + "img/ch25.ac86c633.jpg";